<template>
    <div class="project">
        <el-menu theme="dark" :default-active="activeIndex" class="el-menu-demo" mode="horizontal"
                 @select="handleSelect" router>
            <el-menu-item index="/home/charge/charge_list">收费列表</el-menu-item>
        </el-menu>
        <router-view></router-view>
    </div>
</template>
<script>

  export default {
    name: 'project',
    data() {
      return {
        msg: '项目',
        activeIndex: '/home/charge/charge_list',
        handleSelect(key, keyPath) {
          console.log(key, keyPath);
        }
      }
    },

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// charge_menu.vue?216c2848